import { FunctionComponent } from 'react';

import { m as motion, useTransform, useViewportScroll } from 'framer-motion';
import { useMedia } from 'react-use';
import styled from 'styled-components';

import { Button, ButtonType } from 'chime-ui/components/Button';
import { colors } from 'chime-ui/system';
import media, { screenSizes } from 'chime-ui/system/media';

type StickableButtonType = ButtonType & {
  showLogin?: boolean;
  loginProps?: Record<string, unknown>;
};

type StickyButtonType = StickableButtonType;

const StickyButton: FunctionComponent<StickyButtonType> = ({
  children,
  ...props
}) => (
  <StickyWrapper>
    <Button {...props}>{children}</Button>
  </StickyWrapper>
);

export const StickyWrapper: FunctionComponent = ({ children }) => {
  const isTablet = useMedia(`(min-width: ${screenSizes.tablet}px)`);
  const { scrollY } = useViewportScroll();
  const shadowScale = useTransform(
    scrollY,
    [0, 50],
    ['0px -2px 4px rgba(0, 0, 0, 0)', '0px -2px 4px rgba(0, 0, 0, 0.1)']
  );

  return (
    <StyledStickyWrapper
      style={{
        boxShadow: isTablet ? 'none' : shadowScale,
      }}
    >
      {children}
    </StyledStickyWrapper>
  );
};

const StyledStickyWrapper = styled(motion.div)`
  ${media.mobileOnly` 
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  `}

  ${media.tinyMobileOnly`
    position: initial;
  `}

  background-color: ${colors.white};
  padding: 1.5rem;

  ${media.tablet`
    padding: 1.5rem 0 2.5rem;
  `}
`;

export default StickyButton;
